import { LinkWithTitle } from '@/components/links';
import { ARMATURE_WORKS_TITLE } from '@/pages/destinations/armature-works';
import { BEER_CAN_ISLAND_TITLE } from '@/pages/destinations/beer-can-island';
import { DOWNTOWN_ST_PETE_ST_PETE_PIER_TITLE } from '@/pages/destinations/downtown-st-pete-st-pete-pier';
import { FANTASY_ISLAND_TITLE } from '@/pages/destinations/fantasy-island';
import { SPARKMAN_WHARF_TITLE } from '@/pages/destinations/sparkman-wharf';
import { TAMPA_RIVERWALK_TITLE } from '@/pages/destinations/tampa-riverwalk';

export const DestinationsList = () => {
  return (
    <>
      <li>
        <LinkWithTitle to="/destinations/armature-works">
          {ARMATURE_WORKS_TITLE}
        </LinkWithTitle>
      </li>
      <li>
        <LinkWithTitle to="/destinations/beer-can-island">
          {BEER_CAN_ISLAND_TITLE}
        </LinkWithTitle>
      </li>
      <li>
        <LinkWithTitle to="/destinations/downtown-st-pete-st-pete-pier">
          {DOWNTOWN_ST_PETE_ST_PETE_PIER_TITLE}
        </LinkWithTitle>
      </li>
      <li>
        <LinkWithTitle to="/destinations/fantasy-island">
          {FANTASY_ISLAND_TITLE}
        </LinkWithTitle>
      </li>
      <li>
        <LinkWithTitle to="/destinations/sparkman-wharf">
          {SPARKMAN_WHARF_TITLE}
        </LinkWithTitle>
      </li>
      <li>
        <LinkWithTitle to="/destinations/tampa-riverwalk">
          {TAMPA_RIVERWALK_TITLE}
        </LinkWithTitle>
      </li>
    </>
  );
};
